type PublicationTokenRequest = {
  publicationKey: string;
  tenantId: string;
  userId: string;
  isLegacy?: boolean;
};

type PublicationAuthRequest = {
  tenantId: string | null;
  userId: string | null;
  publicationKey?: string;
  isLegacy?: boolean;
};

type PublicationRefreshRequest = {
  grant_type: string;
  refresh_token?: string;
  isLegacy?: boolean;
};

type PostOptions<T> = NonNullable<Parameters<typeof $fetch<T>>[1]>;

const ensureLeadingSlash = (value: string) => value.startsWith('/') ? value : `/${value}`;

export const useCirrusRestApi = () => {
  const { environment } = useEnvironment();

  const baseUrl = computed(() => {
    const subdomain = environment.value === 'production' ? 'api' : `${environment.value}.api`;
    return `https://${subdomain}.colibriocirrus.com`;
  });

  const buildUrl = (path: string) => `${baseUrl.value}${ensureLeadingSlash(path)}`;

  const post = <T>(path: string, options?: PostOptions<T>) => {
    return $fetch<T>(buildUrl(path), {
      method: 'POST',
      ...options
    });
  };

  return {
    buildUrl,
    publication: {
      createToken: (body: PublicationTokenRequest, options?: PostOptions<'json'>) =>
        post<{ requestId?: string; token: string }>('/publication/token', {
          ...options,
          body,
        }),
      authorise: (body: PublicationAuthRequest, options?: PostOptions<'json'>) =>
        post('/publication/auth', {
          ...options,
          body,
        }),
      refresh: (body: PublicationRefreshRequest, options?: PostOptions<'json'>) =>
        post('/publication/refresh', {
          ...options,
          body,
        }),
    },
  };
};
